import { apiFetch } from './client';

export async function fetchMenuItems() {
    try {
        // Prima tenta l'endpoint /api/menu/snapshot che restituisce tutto in un colpo solo
        const res = await apiFetch('/api/menu/snapshot');
        if (res.ok) {
            const data = await res.json();
            return data.products; // Restituisce solo i prodotti
        }

        // Fallback: endpoint originale
        const fallback = await apiFetch('/api/menuitem');
        if (!fallback.ok) throw new Error('Errore caricamento prodotti');
        return fallback.json();
    } catch (error) {
        console.error('Errore caricamento prodotti:', error);
        // Ultimo fallback: endpoint DTO
        const lastAttempt = await apiFetch('/api/menuitem/dto?restaurantId=1');
        if (!lastAttempt.ok) throw new Error('Errore caricamento prodotti - tutti i tentativi falliti');
        return lastAttempt.json();
    }
}

export async function createMenuItem(data: any) {
    const res = await apiFetch('/api/menuitem', { method: 'POST', body: JSON.stringify(data) });
    if (!res.ok) throw new Error('Errore creazione prodotto');
    return res.json();
}

export async function updateMenuItem(id: number | string, data: any) {
    const res = await apiFetch(`/api/menuitem/${id}`, { method: 'PUT', body: JSON.stringify(data) });
    if (!res.ok) throw new Error('Errore aggiornamento prodotto');
    return res.json();
}

export async function deleteMenuItem(id: number | string) {
    const res = await apiFetch(`/api/menuitem/${id}`, { method: 'DELETE' });
    if (!res.ok) throw new Error('Errore eliminazione prodotto');
    return true;
}

export async function reorderMenuItems(items: { id: number | string; sortOrder: number }[]) {
    const res = await apiFetch('/api/menuitem/reorder', {
        method: 'PUT',
        body: JSON.stringify(items)
    });
    if (!res.ok) throw new Error('Errore riordino prodotti');
    return true;
}
